import { domToPng } from 'modern-screenshot'
import React from 'react'
import ReactDOM from 'react-dom/client'

export function toPng(
  node: React.ReactElement<{ ref: React.Ref<HTMLElement> }>,
  opts?: {
    delay?: number
    minHeightRatio?: number
    restoreScrollPosition?: boolean
  }
) {
  const containerElement = document.createElement('div')
  containerElement.style.position = 'fixed'
  containerElement.style.opacity = '0'
  document.body.appendChild(containerElement)

  const rootElement = document.createElement('div')
  if (opts?.minHeightRatio) {
    rootElement.style.display = 'flex'
    rootElement.style.alignItems = 'center'
    rootElement.style.justifyContent = 'center'
  }
  containerElement.appendChild(rootElement)
  const root = ReactDOM.createRoot(rootElement)

  return new Promise<string>((resolve) =>
    root.render(
      React.cloneElement(node, {
        ref: (element) => {
          const width = element!.offsetWidth
          let height = element!.offsetHeight
          if (opts?.minHeightRatio) {
            const minHeight = Math.ceil(width * opts.minHeightRatio)
            if (height < minHeight) height = minHeight
          }
          setTimeout(() => {
            domToPng(rootElement, {
              height,
              width,
              scale: 6,
              features: {
                restoreScrollPosition: opts?.restoreScrollPosition,
              },
            }).then((url) => {
              resolve(url)
              document.body.removeChild(containerElement)
            })
          }, opts?.delay ?? 0)
        },
      })
    )
  )
}
